// src/mobile/fab.ts
import { EventManager, setupEventListenersIfNeeded } from './event-manager';
import { FloatingActionButtonConfig } from './types';
import { postJsMessage } from '../../../bridge';
import API from '../../../api';

const FAB_ACTION_ID = 'zm_global_floating_action_button';

export function setFloatingActionButtonConfig(
  config: FloatingActionButtonConfig
): Promise<any> {
  setupEventListenersIfNeeded();

  // Cleanup previous callback
  EventManager.getInstance().unregisterCallback(
    'onFloatingActionButtonClick',
    FAB_ACTION_ID
  );

  if (config.onTap) {
    EventManager.getInstance().registerCallback(
      'onFloatingActionButtonClick',
      FAB_ACTION_ID,
      config.onTap
    );
  }

  return postJsMessage(API.setFloatingActionButtonConfig, {
    ...config,
    onTap: undefined,
  });
}
